var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{attrs:{"icon":"arrow-left"},on:{"click":_vm.goback}},[_vm._v(" 返回列表 ")])}
var staticRenderFns = []

export { render, staticRenderFns }